import { HeImgix } from '../images/HeImgix';
import { ImageContainer } from './SocialImage.styles';

export const SocialImage = ({ src }: { src: string }) => (
  <ImageContainer>
    <HeImgix
      aria-label=""
      src={src}
      width={16}
      height={16}
      imgixParams={{ w: 16, h: 16 }}
      htmlAttributes={{ alt: '' }}
    />
  </ImageContainer>
);
